import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import CatalogoSolicitudOrdenComprasAprob from '../../catalogos/catalogoSolicitudOrdenCompra';
import moment from 'moment';

export const AgregarSolicitud = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtIdcor = useRef();
    const txtRazon = useRef();
    const txtIdprov = useRef();
    const txtFecha = useRef();
    const txtObserv = useRef();
    const txtDescriclas = useRef();
    const txtMonto = useRef();
    const txtMontoiv = useRef();
    const txtFechacrea = useRef();
    const txtTipo = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
    };

    const onCheck = () => {

        if (txtChk1.current.checked) {
            setVal2(1);
        } else if (txtChk2.current.checked) {
            setVal2(2);
        }

    }


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaSolicitudes = (idcordinacion, razonsocial, concepto, idproveedor, idordencompra, fecha, observaciones, monto, montoiva, fechacrea, tipo, idordenservicio) => {
        setMostrar4(false);

        txtId.current.value = idordencompra !== null ? idordencompra : idordenservicio;
        txtDescriclas.current.value = concepto;
        txtIdcor.current.value = idcordinacion;
        txtRazon.current.value = razonsocial;
        txtIdprov.current.value = idproveedor;
        txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
        txtObserv.current.value = observaciones;
        txtMonto.current.value = monto;
        txtMontoiv.current.value = montoiva;
        txtFechacrea.current.value = moment.utc(fechacrea).format('DD-MM-YYYY');
        txtTipo.current.value = tipo;

        if (idordencompra > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);

    }
    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarOrdenesCompras = (id) => {

        let idtext = "";
        if (val2 === 1) {
            idtext = 'idordencompra';
        } else {
            idtext = 'idordenservicio';
        }

        let endpoint = `${op.conexion}/api/comprasAlmacen/solicitudesdecomprasinput?tabid=${idtext}&idorden=${id}&idefiscal=${idefiscal}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                if (response.data.idordencompra > 0) {
                    setActivate(false);
                    txtId.current.value = response.data.idordencompra !== null ? response.data.idordencompra : response.data.idordenservicio;
                    txtDescriclas.current.value = response.data.concepto;
                    txtIdcor.current.value = response.data.idcordinacion;
                    txtRazon.current.value = response.data.razonsocial;
                    txtIdprov.current.value = response.data.idproveedor;
                    txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                    txtObserv.current.value = response.data.observacion;
                    txtMonto.current.value = response.data.monto;
                    txtMontoiv.current.value = response.data.montoiva;
                    txtFechacrea.current.value = moment.utc(response.data.fecha_crea).format('DD-MM-YYYY');
                    txtTipo.current.value = response.data.tipo;

                    if (response.data.idordencompra > 0) {
                        setVal(1);
                    } else {
                        setVal(2);
                    }
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                }

            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const handleSolicitudes = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarOrdenesCompras(event.target.value);
            }
        }
    };

    const seleccionarSolicitudesCompras = () => {
        blanquear();
        var datos = [];
        datos.push({
            idcordinacion: txtIdcor.current.value,
            razonsocial: txtRazon.current.value.trim(),
            concepto: txtDescriclas.current.value.trim(),
            idproveedor: txtIdprov.current.value,
            idordencompra: txtId.current.value,
            fecha: txtFecha.current.value,
            observaciones: txtObserv.current.value.trim(),
            monto: txtMonto.current.value,
            montoiva: txtMontoiv.current.value,
            fechacrea: txtFechacrea.current.value,
            tipo: txtTipo.current.value,
            val: val
        })
        props.onDatos(datos);
        props.onHideCancela();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion === 1) {
                    txtChk1.current.checked = true;
                    txtChk2.current.checked = false;
                    setVal2(1);
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>Documento a Aprobar</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoSolicitudOrdenComprasAprob
                    show={mostrar4}
                    tipo={txtChk1.current && txtChk1.current.checked ? '0' : '1'}
                    onHideCancelar={handleCancelaras}
                    onHideAceptarSolicitud={handleAceptaSolicitudes}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div>

                    <input type='hidden' ref={txtIdcor} />
                    <input type='hidden' ref={txtRazon} />
                    <input type='hidden' ref={txtIdprov} />
                    <input type='hidden' ref={txtFecha} />
                    <input type='hidden' ref={txtObserv} />
                    <input type='hidden' ref={txtMonto} />
                    <input type='hidden' ref={txtMontoiv} />
                    <input type='hidden' ref={txtFechacrea} />
                    <input type='hidden' ref={txtTipo} />


                    <div className='col-md-12 py-2'></div>

                    <fieldset className="row border-azul rounded mx-auto">
                        <legend className="float-none m-0 w-auto">Incluir Documento</legend>

                        <div className='container row m-0 d-flex justify-content-center col-12 mx-auto px-0'>

                            <div className='mb-2'></div>

                            <div className='row m-0 px-2 col-md-12 mx-auto mb-2 border-azul rounded'>

                                <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                    <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                    <label className="form-check-label" for="flexRadioDefault1">
                                        Compras
                                    </label>
                                </div>
                                <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                    <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                    <label className="form-check-label" for="flexRadioDefault2">
                                        Servicios
                                    </label>
                                </div>

                            </div>

                            <div className='col-sm-3 mb-2 px-1'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" name='codigo' ref={txtId} onKeyUp={handleSolicitudes} onBlur={handleInputNumChange} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-info" ><i className="fa fa-search"></i> </button>
                                </div>
                            </div>

                            <div className='col-sm-9 px-1'>
                                <div className='col-sm-12 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Concepto:</label>
                                        <textarea type="text" className="form-control text-uppercase" style={{ height: '60px' }} disabled={true} ref={txtDescriclas} placeholder="Descripción del Documento" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={seleccionarSolicitudesCompras} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}